import axios from 'axios';
import { ADMIN_ENDPOINT } from 'src/config';

export default function writeLog({ event_type, content }) {
  return axios.post(`${ADMIN_ENDPOINT}/writeLog`, {
    event_type: event_type,
    content: content,
  });
}
